import { render, staticRenderFns } from "./ViewBook.vue?vue&type=template&id=15ab4ff0&scoped=true"
import script from "./ViewBook.vue?vue&type=script&lang=js"
export * from "./ViewBook.vue?vue&type=script&lang=js"
import style0 from "./ViewBook.vue?vue&type=style&index=0&id=15ab4ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ab4ff0",
  null
  
)

export default component.exports